import React from 'react'
import Helmet from 'react-helmet'
import { Flex, Text } from '@sketch/components'
import HeaderBadge from 'modules/shares/components/HeaderBadge'
import Breadcrumbs from 'modules/shares/components/HeaderNavigation/Breadcrumbs'
import ShareWorkspaceSidebar from 'modules/shares/components/ShareWorkspaceSidebar'
import EditorNavbar from './EditorNavbar'
import EditorSidebar from './EditorSidebar'
import DocumentSidebarLayout from 'containers/DocumentSidebarLayout'
import { ContentWrapper, StyledDSIcon, Header } from './EditorLayout.styles'
import {
  DesignSystem as DesignSystemType,
  DesignSystemSection,
} from '../../types'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'

interface EditLayoutProps {
  designSystem: DesignSystemType
  workspace: WorkspaceMinimalFragment | undefined
  sections: DesignSystemSection[]
}

const EditorLayout: React.FC<EditLayoutProps> = ({
  children,
  workspace,
  designSystem,
  sections,
}) => {
  const userIsGuest =
    workspace?.userRole === 'GUEST' || workspace?.userRole === undefined

  if (!workspace) {
    return null
  }

  return (
    <>
      <Helmet>
        <meta name="theme-color" content="#F0F0F0" />
      </Helmet>
      <DocumentSidebarLayout
        title={`Design System - ${designSystem.name}`}
        sidebarLeft={
          <ShareWorkspaceSidebar workspaceIdentifier={workspace.identifier} />
        }
        header={({ setSidebarLeftOpen }) => (
          <Header>
            {workspace && (
              <HeaderBadge
                type={!userIsGuest ? 'workspace' : 'home'}
                workspace={workspace}
                setSidebarLeftOpen={setSidebarLeftOpen}
              />
            )}
            <Flex mt={1} width="100%">
              <Breadcrumbs>
                <Flex alignItems="self-start">
                  <StyledDSIcon />
                  <Text
                    color="foreground.secondary.C"
                    fontSize="D"
                    fontWeight="medium"
                  >
                    Design Systems
                  </Text>
                </Flex>
                <Text
                  color="foreground.secondary.B"
                  fontSize="D"
                  fontWeight="medium"
                >
                  {designSystem.name}
                </Text>
              </Breadcrumbs>
            </Flex>
            <EditorNavbar
              userIsGuest={userIsGuest}
              designSystem={designSystem}
            />
          </Header>
        )}
        footer={<></>}
      >
        <Flex flexDirection="row">
          <EditorSidebar
            workspace={workspace}
            designSystem={designSystem}
            sections={sections}
          />
          <ContentWrapper>{children}</ContentWrapper>
        </Flex>
      </DocumentSidebarLayout>
    </>
  )
}
export default EditorLayout
